import React from 'react';
import { action, computed, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { INumberPickerConfiguration, INumberPickerProps, INumberPickerState } from './models/index.js';
import SelectedValue from './styledComponents/SelectedValue.js';
import Value from './styledComponents/Value.js';
import Wrapper from './styledComponents/Wrapper.js';
import { NUMBER_PICKER_CATEGORY_KEY, NUMBER_PICKER_COMPONENT_KEY } from './NumberPicker.meta.js';

export class NumberPicker extends ComponentBase<INumberPickerProps, INumberPickerState, INumberPickerConfiguration> {
	categoryKey = NUMBER_PICKER_CATEGORY_KEY;
	componentKey = NUMBER_PICKER_COMPONENT_KEY;

	value: number | undefined;	

	constructor(props: INumberPickerProps) {
		super(props);
		this.value = props.value;

		makeObservable(this, {
			value: observable,
			handleChange: action,
			valueComponents: computed,
		});	
	}
	
	handleChange(value: number) {
		const { onChange } = this.props;
		this.value = value;
		if (onChange) {
			onChange(value);
		}
	}

	get valueComponents(): any[] {
		const { startValue, endValue, increment = 1 } = this.props;
		const result: any[] = [];
		if (startValue <= endValue && increment > 0) {
			for (let value = startValue; value <= endValue; value += increment) {
				// eslint-disable-next-line @typescript-eslint/naming-convention
				const ValueComponent = value === this.value ? SelectedValue : Value;
				result.push(
					<ValueComponent key={`value_${value}`} onClick={() => this.handleChange(value)}>
						{value}
					</ValueComponent>,
				);
			}
		} else if (startValue >= endValue && increment < 0) {
			for (let value = startValue; value >= endValue; value += increment) {
				// eslint-disable-next-line @typescript-eslint/naming-convention
				const ValueComponent = value === this.value ? SelectedValue : Value;
				result.push(
					<ValueComponent key={`value_${value}`} onClick={() => this.handleChange(value)}>
						{value}
					</ValueComponent>,
				);
			}
		}
		return result;
	}

	render() {
		const { className } = this.props;
		return <Wrapper className={className}>{this.valueComponents}</Wrapper>;
	}
}

export default InjectedStyledComponent(observer(NumberPicker), NUMBER_PICKER_CATEGORY_KEY, NUMBER_PICKER_COMPONENT_KEY);
